// @flow
import React, {
  useRef,
  useState,
  createRef,
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Steps,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  notificationActions,
  shopDetailsActions,
} from 'store/actions';
import { SpButton } from 'components/DesignKit';

import Stocks from './Stocks';
import Basics from './Basics';
import Details from './Details';

type Props = {
  close: Function,
  visible: boolean,
  submitting: boolean,
  test: boolean,
  selectedAccount: Object,
  phoneCode: string,
  submit: Function,
  itemsList: Array,
  fetchAllShopDetails: Function,
  modifierItemsList: Array,
  labelList: Array,
  shopsList: Array,
  inventoryCategorieDetails: Object,
  };

const { Step } = Steps;

const AddNewItem = (props: Props) => {
  const {
    visible,
    close,
    submitting,
    selectedAccount,
    phoneCode,
    submit,
    test,
    itemsList,
    modifierItemsList,
    labelList,
    shopsList,
    fetchAllShopDetails,
    inventoryCategorieDetails,
  } = props;

  const [, forceUpdate] = useState();
  const basicsRef = createRef();
  const detailsRef = createRef();
  const discountRef = createRef();
  const currencyType = selectedAccount && selectedAccount.currency;
  const [refArray, setRefArray] = useState([basicsRef, detailsRef, discountRef]);
  const [current, setCurrent] = useState(0);
  const simpleValidator = useRef(new SimpleReactValidator());
  const [disableButton, setDisableButton] = useState(false);
  const [name, setName] = useState('');
  const [alternateName, setAlternateName] = useState('');
  const [onlineName, setOnlineName] = useState(null);
  const [code, setCode] = useState(null);
  const [onlineEnabled, setOnlineEnabled] = useState(true);
  const [sku, setSku] = useState('');
  const [price, setPrice] = useState(null);
  const [cost, setCost] = useState(null);
  const [priceType, setPriceType] = useState('');
  const [unitName, setUnitName] = useState('');
  const [primaryColor, setColorCode] = useState('#007bff');
  const [logoUrl, setLogo] = useState('');
  const [preview, setPreview] = useState('');
  const [fileName, setFileName] = useState('');
  const [description, setDescription] = useState();
  const [tagDetails, setTagDetails] = useState();
  const [order, setOrder] = useState('');
  const [categories, setCategories] = useState('');
  const [shopDetails, setShopDetails] = useState('');
  const [isPos, setIsPos] = useState(false);
  const [isItemAvailable, setIsItemAvailable] = useState(true);
  const [isRecurring, setIsRecurring] = useState(true);
  const [isKiosk, setIsKiosk] = useState(true);
  const [collectLineItemDate, setCollectLineItemDate] = useState(false);
  const [modifierGroups, setModifierGroups] = useState('');
  const [enableStock, setEnableStock] = useState(false);
  const [enableDynamicAvailability, setEnableDynamicAvailability] = useState(false);
  const [stockQuantity, setStockQuantity] = useState(null);
  const [onlineAvailability, setOnlineAvailability] = useState(null);
  const [posAvailability, setPosAvailability] = useState(null);

  const basicsData = {
    name,
    onlineName,
    onlineEnabled,
    alternateName,
    sku,
    price,
    cost,
    priceType,
    unitName,
    primaryColor,
    code,
  };

  const detailsData = {
    logoUrl,
    preview,
    fileName,
    description,
    tagDetails,
    order,
    categories,
    isItemAvailable,
    isRecurring,
    isKiosk,
    collectLineItemDate,
    modifierGroups,
    isPos,
    shopDetails,
  };

  const stockDetails = {
    enableStock,
    enableDynamicAvailability,
    stockQuantity,
    onlineAvailability,
    posAvailability,
  };

  useEffect(() => {
    if (current === 2 && !submitting) {
      setDisableButton(false);
    }
  }, [submitting]);

  useEffect(() => {
    setRefArray(existingElements => (
      [...existingElements]
    ));
    fetchAllShopDetails('&sortBy=createdAt&direction=DESC');
  }, []);

  const next = async () => {
    const validationArray = [];
    const valuesArray = [];
    if (current === 0) {
      validationArray.push(refArray[0].current.validate());
      valuesArray.push(refArray[0].current.getValues());
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setName(valuesArray[0].name);
      setAlternateName(valuesArray[0].alternateName);
      setOnlineName(valuesArray[0].onlineName);
      setCode(valuesArray[0].code);
      setOnlineEnabled(valuesArray[0].onlineEnabled);
      setPrice(valuesArray[0].price);
      setSku(valuesArray[0].sku);
      setCost(valuesArray[0].cost);
      setPriceType(valuesArray[0].priceType);
      setUnitName(valuesArray[0].unitName);
      setColorCode(valuesArray[0].primaryColor);
      setCurrent(current + 1);
    } else if (current === 1) {
      validationArray.push(refArray[1].current.validate());
      const details = refArray[1].current.getValues();
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setLogo(details.logoUrl);
      setPreview(details.preview);
      setFileName(details.fileName);
      setDescription(details.description);
      setTagDetails(details.tagDetails);
      setOrder(details.order);
      setCategories(details.categories);
      setShopDetails(details.shopDetails);
      setIsPos(details.isPos);
      setIsItemAvailable(details.isItemAvailable);
      setIsRecurring(details.isRecurring);
      setIsKiosk(details.isKiosk);
      setCollectLineItemDate(details.collectLineItemDate);
      setModifierGroups(details.modifierGroups);
      setCurrent(current + 1);
    } else if (current === 2) {
      validationArray.push(refArray[2].current.validate());

      setDisableButton(true);

      const stocksData = refArray[2].current.getValues();
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setEnableStock(stocksData.enableStock);
      setEnableDynamicAvailability(stocksData.enableDynamicAvailability);
      setStockQuantity(stocksData.stockQuantity);
      setOnlineAvailability(stocksData.onlineAvailability);
      setPosAvailability(stocksData.posAvailability);
      const payload = Object.assign(basicsData, detailsData, stocksData);
      submit(
        payload,
      );
    }
  };

  const prev = () => {
    const validationArray = [];
    const valuesArray = [];
    setDisableButton(false);
    if (current === 0) {
      validationArray.push(refArray[0].current.validate());
      valuesArray.push(refArray[0].current.getValues());
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setName(valuesArray[0].name);
      setAlternateName(valuesArray[0].alternateName);
      setOnlineName(valuesArray[0].onlineName);
      setCode(valuesArray[0].code);
      setOnlineEnabled(valuesArray[0].onlineEnabled);
      setPrice(valuesArray[0].price);
      setSku(valuesArray[0].sku);
      setCost(valuesArray[0].cost);
      setPriceType(valuesArray[0].priceType);
      setUnitName(valuesArray[0].unitName);
      setColorCode(valuesArray[0].primaryColor);
      setCurrent(current + 1);
      close();
    } else if (current === 1) {
      validationArray.push(refArray[1].current.validate());
      const details = refArray[1].current.getValues();
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setLogo(details.logoUrl);
      setPreview(details.preview);
      setFileName(details.fileName);
      setDescription(details.description);
      setTagDetails(details.tagDetails);
      setOrder(details.order);
      setCategories(details.categories);
      setShopDetails(details.shopDetails);
      setIsPos(details.isPos);
      setIsItemAvailable(details.isItemAvailable);
      setIsRecurring(details.isRecurring);
      setIsKiosk(details.isKiosk);
      setCollectLineItemDate(details.collectLineItemDate);
      setModifierGroups(details.modifierGroups);
      setCurrent(current + 1);
      setCurrent(current - 1);
    } else if (current === 2) {
      validationArray.push(refArray[2].current.validate());
      const stocksData = refArray[2].current.getValues();
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setEnableStock(stocksData.enableStock);
      setEnableDynamicAvailability(stocksData.enableDynamicAvailability);
      setStockQuantity(stocksData.stockQuantity);
      setOnlineAvailability(stocksData.onlineAvailability);
      setPosAvailability(stocksData.posAvailability);
      setCurrent(current - 1);
    } else if (current === 3) {
      setCurrent(current - 1);
    }
  };


  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      width="540px"
      footer={current === 0
        ? [
          <SpButton key="1" onClick={() => close()} type="secondary">Cancel</SpButton>,
          <SpButton key="2" onClick={next}>Next</SpButton>,
        ]
        : current === 1
          ? [
            <SpButton key="1" onClick={() => close()} type="secondary">Cancel</SpButton>,
            <SpButton key="3" onClick={prev} type="secondary">Previous</SpButton>,
            <SpButton key="2" onClick={next}>Next</SpButton>,
          ]
          : [
            <SpButton key="1" onClick={() => close()} type="secondary">Cancel</SpButton>,
            <SpButton key="3" onClick={prev} type="secondary">Previous</SpButton>,
            <SpButton key="2" onClick={next} disabled={disableButton}>Add</SpButton>,
          ]}
      title="Add Item"
    >
      <>
        <div style={{ marginTop: '-8px' }}>
          <Steps current={current} className="subscriptions">
            <Step key="1" title="Basics" />
            <Step key="2" title="Details" />
            <Step key="3" title="Stocks" />
          </Steps>
        </div>
        <div className="px-5 mt-2">
          <div className={submitting ? 'OVERLAY' : ''} />
          {current === 0 && (
            <Basics
              ref={refArray[0]}
              selectedAccount={selectedAccount}
              basicsData={basicsData}
              currencyType={currencyType}
            />
          )}
          {current === 1 && (
            <Details
              ref={refArray[1]}
              selectedAccount={selectedAccount}
              currencyType={currencyType}
              phoneCode={phoneCode}
              test={test}
              basicsData={basicsData}
              detailsData={detailsData}
              itemsList={itemsList}
              modifierItemsList={modifierItemsList}
              labelList={labelList}
              shopsList={shopsList}
              inventoryCategorieDetails={inventoryCategorieDetails}
            />
          )}
          {current === 2 && (
            <Stocks
              ref={refArray[2]}
              selectedAccount={selectedAccount}
              basicsData={basicsData}
              detailsData={detailsData}
              stockDetails={stockDetails}
            />
          )}
        </div>
      </>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
  selectedAccount: state.account.selectedAccount,
  shopsList: state.shopDetails.shopsList.content,

});

const mapDispatchToProps = (dispatch) => ({
  fetchAllShopDetails: (payload) => dispatch(shopDetailsActions.fetchAllShopDetails({
    payload,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(AddNewItem);
